module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


//////////////////
// WEBPACK FOOTER
// external "mobxReact"
// module id = 4
// module chunks = 6 7